export const LEITWEG_ID_HELP =
  "Vom Rechnungsempfänger vorgegebene Kennung für die E-Rechnung. Wird als Käuferreferenz (BT-10) übertragen.";
